import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { WhatWeDoLogic, useStyles } from './whatWeDo.module';

const WhatWeDo = () => {
  const { translator } = WhatWeDoLogic();
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <Typography variant="h3" className={classes.title}>
          {translator('whatWeDo.title')}
          <span className={classes.titleGreen}>
            {' '}
            {translator('whatWeDo.title2')}
          </span>
        </Typography>

        <Typography variant="body1" className={classes.text}>
          <span className={classes.textBold}>
            {translator('whatWeDo.textBold1')}
          </span>{' '}
          {translator('whatWeDo.text1')}
          <span className={classes.textBold}>
            {translator('whatWeDo.textBold2')}
          </span>{' '}
          {translator('whatWeDo.text2')}
          <span className={classes.textBold}>
            {translator('whatWeDo.textBold3')}
          </span>
          {translator('whatWeDo.text3')}
          <span className={classes.textBold}>
            {' '}
            {translator('whatWeDo.textBold4')}
          </span>
        </Typography>
      </Box>
    </Box>
  );
};

export default WhatWeDo;
